import setSettings from './set-settings';

export default {
  setSettings,
};
